import type { SmartFieldOption } from '../blocks/SmartFormFields.tsx';
import { isRecord } from '../../util/type-guards.ts';

/** Reads localized options and historical string-only Form payloads without changing saved values. */
export function readFormOptions(raw: unknown): SmartFieldOption[] | undefined {
  if (!Array.isArray(raw)) {
    return undefined;
  }
  const options: SmartFieldOption[] = [];
  for (const option of raw) {
    if (typeof option === 'string') {
      options.push({ value: option, label: option });
    } else if (
      isRecord(option) &&
      typeof option.value === 'string' &&
      typeof option.label === 'string'
    ) {
      options.push({ value: option.value, label: option.label });
    }
  }
  return options.length > 0 ? options : undefined;
}

/** Maximum field columns from the `columns` prop, written as `'1'`/`'2'` or `1`/`2`; defaults to 2. */
export function readFormColumns(raw: unknown): 1 | 2 {
  return raw === '1' || raw === 1 ? 1 : 2;
}
